export const DialogLayout = {
  panelClass: 'tmc-dialog-container'
};

